import { reducerWithInitialState } from 'typescript-fsa-reducers';
import type { ArrowType, OrderType } from '@app/react/const/type';

type AvailableOrderPartsReducer = Array<{
    // eslint-disable-next-line camelcase
    arrow_type: ArrowType;
    // eslint-disable-next-line camelcase
    order_type: OrderType;
    items: Array<{ name: string, require: boolean }>;
}>;

const initState: AvailableOrderPartsReducer = [];

export const availableOrderPartsReducer = reducerWithInitialState(initState);
